import { Injectable } from '@angular/core';

import { FileType } from '../shared/models/file-item.model';
import { ConfigParserService } from '../shared/services/config-parser.service';

export interface UploadConfig {
    discreteChunkSize: number;
    editableFileTypes: Set<FileType>;
    fragmentTimeoutInMs: number;
    initialSpeed: number;
    initialWaitDurationInMs: number;
    maxFragmentSize: number;
    maxWaitDurationInMs: number;
    minFragmentSize: number;
    minSpeed: number;
    minUploadDuration: number;
    numClientAttempts: number;
    numServerAttempts: number;
    commonResources: CommonUploadResources;
    oneDriveResources: AppSpecificUploadResources;
    swayResources: AppSpecificUploadResources;
    simpleUploadMaxSize: number;
    slowFragmentTimeoutMultiplier: number;
    slowSpeedDowngradeRatio: number;
    speedDowngradeRatio: number;
    speedUpgradeRatio: number;
    standardWaitDurationInMs: number;
    uploadFileTypes: Set<FileType>;
    dragAndDropEnabled: boolean;
    capPopupEnabled: boolean;
}

export interface CommonUploadResources {
    cancelButtonAriaLabel: string;
    cancelButtonTitle: string;
    checkConnection: string;
    closeButtonAriaLabel: string;
    closeButtonTitle: string;
    completedSubtitle: string;
    completedTitle: string;
    progressText: string;
    retryButtonAriaLabel: string;
    retryButtonTitle: string;
    uploadButtonAriaLabel: string;
    uploadButtonTitle: string;
}

export interface AppSpecificUploadResources {
    progressTitle: string;
    openWarning: string;
    errorTitle: string;
    multipleFilesErrorTitle: string;
    outOfSpace: string;
    largeFile: string;
    unsupportedFile: string;
    multipleFiles: string;
    dragAndDropTip: string;
}

@Injectable({
    providedIn: 'root'
})
export class UploadConfigService {
    public readonly config: UploadConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<UploadConfig>('uploadConfig');

        if (this.config) {
            this.config.uploadFileTypes = new Set([FileType.Excel, FileType.Word, FileType.PowerPoint, FileType.Visio, FileType.Stream]);
            this.config.editableFileTypes = new Set([FileType.Excel, FileType.Word, FileType.PowerPoint]);
        }
    }
}
